import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import Main from "./Components/Main";
import AutoLoadServices from "Services/AutoLoadServices";

AutoLoadServices.load();

ReactDOM.render(
	<React.StrictMode>
		<Main />
	</React.StrictMode>,
	document.getElementById("root"),
);
